import { useLayoutEffect, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { motion } from "framer-motion"

import AppLayout from "layouts/app-layout"
import Transition from "components/transition"
import axios from "axios"
import Form from "./form"
import { useAuth } from "contexts/auth-context"
import nProgress from "nprogress"
import { toast } from "react-hot-toast"

const CreateRole = ({ title }) => {
    const { user } = useAuth()

    const location = useLocation()
    const navigate = useNavigate()

    const [prevRouteState, setPrevRouteState] = useState({})

    const [errors, setErrors] = useState({})

    useLayoutEffect(() => {
        const getPrevRouteState = async () => {
            setPrevRouteState({
                back: location.state?.back,
                from: location.state?.from,
                transition: location.state?.transition
            })
        }

        getPrevRouteState()
    }, [])

    const handleSubmit = (data) => {
        nProgress.start()

        axios.post(`${process.env.REACT_APP_GLOBAL_API_URL}/role/store`, {
            name: data.name,
            application_id: 2,
            permission: data.permission,
            created_by: user?.name
        }).then((response) => {
            navigate({ pathname: '/role' })
            toast.success(response.data.message)
            nProgress.done()
        }).catch(error => {
            if (error.response.status === 422) {
                setErrors(error.response.data.errors)
            }
            toast.error(error.response.data.message)
            nProgress.done()
            console.log(error.response)
        })
    }

    return (
        <AppLayout title={title}>
            <div className="p-4 lg:p-8 space-y-16">
                <div>
                    {prevRouteState?.back && (
                        <button className="transition hover:opacity-50" onClick={() => navigate(-1, { state: { transition: "slide" } })}>
                            <motion.h3 layout transition={{ duration: .5, type: "tween" }} layoutId={prevRouteState?.back} className="text-sm">{prevRouteState?.back}</motion.h3>
                        </button>
                    )}
                    <Transition reversed>
                        <h1 className="text-3xl font-medium">
                            {title}
                        </h1>
                    </Transition>
                </div>
                <Transition type="slide" reversed>
                    <Form errors={errors} onSubmit={handleSubmit} />
                </Transition>
            </div>
        </AppLayout >
    )
}

export default CreateRole